import { PeriscopeRelatedObject } from '.';
import { usePeriscopeActions } from '@hooks';
import { EntityReference, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';

export interface PeriscopeRelatedObjectsListProps {
	relatedObjects: EntityReference[];
	parentIndex: number;
}

export const PeriscopeRelatedObjectsList: React.FC<PeriscopeRelatedObjectsListProps> = ({
	relatedObjects,
	parentIndex
}) => {
	const { openPeriscope } = usePeriscopeActions();

	const handleRelatedObjectClick = useCallback(
		(relatedObject: EntityReference) => {
			const { displayName, sonarObjectId } = relatedObject;

			openPeriscope({
				id: sonarObjectId,
				name: displayName,
				openedFromIndex: parentIndex,
				type: SonarObjectType.SalesforceEntity
			});
		},
		[ openPeriscope, parentIndex ]
	);

	return (
		<>
			{ relatedObjects.map((relatedObject) =>
				<PeriscopeRelatedObject
					key={ relatedObject.displayName }
					onRelatedObjectClick={ handleRelatedObjectClick }
					relatedObject={ relatedObject } />) }
		</>
	);
};
